import axios, { AxiosPromise } from 'axios'
import applyCaseMiddleware from 'axios-case-converter'
import { AuthInterceptorRequestFullfiled } from 'src/services/interceptors/request'
import {
  INormalizeResponse,
  NormalizeInterceptorResponseFullfiled,
  ErrorProcessing,
} from 'src/services/interceptors/response'
import * as locationService from 'src/services/location'

const parner = locationService.getPartner()
const domain = window.settings.BASE_MAIL_DOMAIN

export const baseURL = `//${parner}.${domain}/api`
export const authURL = `//${domain}`

export type IResponse<data> = INormalizeResponse<data>
export type HTTPPromise<Data> = AxiosPromise<Data>

export const http = axios.create({
  baseURL,
  withCredentials: false,
})

export const authHttp = axios.create({
  baseURL: authURL,
  withCredentials: false,
})

applyCaseMiddleware(http)
applyCaseMiddleware(authHttp)

http.interceptors.response.use(
  NormalizeInterceptorResponseFullfiled,
  ErrorProcessing
)
http.interceptors.request.use(AuthInterceptorRequestFullfiled)

authHttp.interceptors.response.use(
  NormalizeInterceptorResponseFullfiled,
  ErrorProcessing
)
authHttp.interceptors.request.use(AuthInterceptorRequestFullfiled)
